import React from "react";
import "../Css/Test.css";
import worldcom_pic from "../welcome_component/images/me.svg";

function More() {
  return (
    <div className="sepNav">
      <div className="row1">
        <div>
          <img src={worldcom_pic} alt="worldcom_pic" />
          <h5 className="titleh1">Who am I?</h5>

          <div className="row1">
            <div className="row1">
              <div
                className="history col-xs-10 col-sm-8 col-md-10"
                style={{ paddingBottom: "100px" }}
              >
                <p className="text-justify">
                  Hi, my name is Murtaza. I am a full stack web developer, I’ve
                  been completed my education in social hackers academy based in
                  Athens Greece. I did not complete high school yet, I’ve been
                  working as a translator, web developer, and team leadership,
                  I’m interested in developing new technologies to help human,
                  especially refugees.
                  <br />I can speak four languages.
                  <strong> Dari, Farsi, English, Greek</strong>
                  and I would like to help refugees by translating their needs
                  as much as possible.
                  <br />
                  and especially refugees, a and these are just my daily
                  interests, in fact, I’m interested in building software in the
                  future that helps the world beings!
                  <br />
                  <br />
                </p>
                
                <h2>
                  {" "}
                  If you are interested in, contact me for more info.
                </h2>{" "}
                <ul>
                  <li>Email Address</li>
                  <td>
                    <tr> murtazahassani105@gmail.com </tr>
                  </td>
                  <br />
                  <li>Phone Number</li>
                  <td>
                    <tr> +306942076251 </tr>
                  </td>
                </ul>
             
                <hr
                  style={{
                    paddingTop: "1px",
                    borderTop: "1px solid black",
                  }}
                ></hr>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default More;
